module.exports = __webpack_public_path__ + "img/haas_f1_team.8278d36c.png";